import { render } from "./CurrentInventory.vue?vue&type=template&id=45e1a6ad"
import script from "./CurrentInventory.vue?vue&type=script&lang=js"
export * from "./CurrentInventory.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__